import ReactApexChart from "react-apexcharts";
import { Grid, Flex, Box } from "@chakra-ui/react";
import DashboardCard from "../../components/dashboard/dashboard-card";
import DeliveryChart from "../../components/dashboard/delivery-chart";
import CollectionChart from "../../components/dashboard/collection-chart";
import { CashierActionList } from "./constants";

export default function Dashboard() {
  const donut = {
    series: [100, 55, 45],
    options: {
      colors: ["rgba(1,55,43,1)", "rgba(1,109,86,1)", "#4D9989"],
      labels: ["Total", "Completed", "Remaining"],
      chart: {
        type: "donut",
        offsetX: 15,
      },
      plotOptions: {
        pie: {
          customScale: 1.12,
          expandOnClick: false,
          offsetY: -20,
          donut: {
            size: "55%",
          },
        },
      },
      title: {
        text: "Bags Assignment",
        position: "left",
        offsetX: -10,
        offsetY: 0,
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: "left",
        offsetX: -20,
        offsetY: 40,
        formatter(val, opts) {
          return `${val} - ${opts.w.globals.series[opts.seriesIndex]}`;
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  };
  return (
    <Flex
      gap="25px"
      p="20px"
      wrap="wrap"
      sx={{
        ".apexcharts-title-text": {
          fontFamily: "inherit !important",
          fill: "primary.500",
          fontSize: "18px",
        },
      }}
    >
      <Grid gap="15px" w="calc(50% - 13px)" gridTemplateColumns="1fr 1fr">
        {CashierActionList?.map((item) => (
          <DashboardCard {...item} key={item?.label} />
        ))}
      </Grid>
      <Box
        id="chart1"
        w="calc(50% - 13px)"
        bg="white"
        shadow="md"
        p="20px"
        sx={{
          ".apexcharts-canvas": {
            m: "0 auto",
          },
        }}
        rounded="8px"
      >
        <ReactApexChart
          options={donut.options}
          series={donut.series}
          type="donut"
          width={340}
        />
      </Box>
      <Box
        rounded="8px"
        id="chart2"
        w="calc(50% - 13px)"
        bg="white"
        shadow="md"
        p="20px"
      >
        <DeliveryChart />
      </Box>
      <Box
        rounded="8px"
        id="chart"
        w="calc(50% - 13px)"
        bg="white"
        shadow="md"
        p="20px"
      >
        <CollectionChart />
      </Box>
    </Flex>
  );
}
